<template>
  <!-- CONTAINER DE CARD SIMPLES PARA CUSTOMIZAR - toolbar - content - actions -->
  <v-container fluid pa-5 class="mt-10">
    <v-row justify="center">
      <v-col cols="12" xs="12" sm="8" md="6" lg="4">
        <v-card class="elevation-12 pa-2" style="border-radius: 12px;" >
          <v-img class="ma-5" contain max-height="50" :src="logo"></v-img>

          <v-card-text>
            <div class="py-5">
              <b>
                <slot name="text"></slot>
              </b>
            </div>
            <!-- Slot para template de form - contents -->
            <slot name="form"></slot>
          </v-card-text>

          <!-- <v-card-actions> -->

          <!-- Slot para template de controls-->
          <v-col cols="12">
            <slot name="control"></slot>
          </v-col>

          <!-- </v-card-actions> -->
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Logo from "@/assets/logos/cimentao.png";
export default {
  props: {
    text: {
      default: "Login",
      type: String
    }
  },
  data() {
    return {
      logo: Logo
    };
  }
};
</script>
